import React, { useState, useEffect, useRef } from 'react';
import { FaPhone, FaEnvelope, FaFacebook, FaLinkedin, FaInstagram, FaYoutube } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import axios from 'axios';
import { Link } from 'react-router-dom';

const TopUtilityHeader = () => {
  const [config, setConfig] = useState(null);
  // console.log("TopUtilityHeader config:", config)
  const [announcements, setAnnouncements] = useState([]);
  console.log("TopUtilityHeader announcements:", announcements)
  const [loading, setLoading] = useState(true);
  const [daysLeft, setDaysLeft] = useState(0);
  const marqueeRef = useRef(null);
  const [marqueeRunning, setMarqueeRunning] = useState(false);

  // Fetch configuration and announcements
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [configRes, announcementsRes] = await Promise.all([
          axios.get('/api/top-utility/config'),
          axios.get('/api/top-utility/announcements')
        ]);

        if (configRes.data.success) {
          setConfig(configRes.data.data);
          calculateDaysLeft(configRes.data.data.targetDate);
        }

        if (announcementsRes.data.success) {
          setAnnouncements(announcementsRes.data.data);
        }
      } catch (error) {
        console.error('Error fetching top utility data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Start marquee after announcements have been rendered and (optionally) after a short delay
  useEffect(() => {
    // Reset running state when announcements change
    setMarqueeRunning(false);

    if (!announcements || announcements.length === 0) return;

    // Give browser a tick to lay out the DOM so measurements are accurate
    const startAfterMeasure = () => {
      const el = marqueeRef.current;
      if (!el) {
        // fallback short delay
        return 800;
      }

      const container = el.parentElement; // visible container
      const containerWidth = container ? container.clientWidth : 0;
      const contentWidth = el.scrollWidth || 0;

      // If content fits inside container, no scrolling needed
      if (contentWidth <= containerWidth) {
        return 0; // keep paused (no animation)
      }

      // Compute delay so users can read the full line before it starts scrolling.
      // Delay is proportional to how wide the content is relative to the container,
      // clamped between 800ms and 5000ms.
      const ratio = contentWidth / Math.max(1, containerWidth);
      const delay = Math.min(5000, Math.max(800, Math.round(ratio * 700)));
      return delay;
    };

    let timeoutId;
    // Use requestAnimationFrame to ensure layout happened
    requestAnimationFrame(() => {
      const delay = startAfterMeasure();
      if (delay === 0) {
        setMarqueeRunning(false);
        return;
      }
      timeoutId = setTimeout(() => setMarqueeRunning(true), delay);
    });

    return () => clearTimeout(timeoutId);
  }, [announcements]);

  // Calculate days left until target date
  const calculateDaysLeft = (targetDate) => {
    const target = new Date(targetDate);
    const today = new Date();
    const diffTime = target - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    setDaysLeft(Math.max(0, diffDays));
  };

  // Update countdown daily
  useEffect(() => {
    const interval = setInterval(() => {
      if (config?.targetDate) {
        calculateDaysLeft(config.targetDate);
      }
    }, 24 * 60 * 60 * 1000); // Update every 24 hours

    return () => clearInterval(interval);
  }, [config]);

  // Handle announcement click
  const handleAnnouncementClick = (url) => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  // Get animation duration based on speed
  const getAnimationDuration = (speed) => {
    switch (speed) {
      case 'slow': return '0.11s';
      case 'fast': return '0.11s';
      default: return '1s';
    }
  };

  if (loading || !config) {
    return (
      <div className="h-12 bg-gray-100 border-b border-gray-200 flex items-center justify-center">
        <div className="animate-pulse text-gray-400 text-sm">Loading...</div>
      </div>
    );
  }

  return (
    <div className="top-utility-header h-20 bg-[#ffffff] border-b-2 border-yellow-400 flex items-center text-base shadow-md w-full text-white">
      {/* Countdown Timer - Left */}
      {/* <div className="countdown-section flex-2 flex justify-start px-2">
        <Link to="https://mahotsavkhasdar.wixsite.com/my-site-4" target="_blank" rel="noopener noreferrer">
          <div className="countdown-box bg-[#470172] font-family-Rubik font-medium px-9 py-3.5 rounded-sm shadow-lg flex items-center border border-yellow-300"


          >
            <span className="countdown-label text-2xl mr-3 text-white">AV 2026 </span>
            <span className="countdown-number text-2xl mr-3 text-white">{daysLeft}</span>
            <span className="countdown-text text-2xl mr-2 text-white">Days to go</span>
          </div>
        </Link>
      </div> */}

      {/* Marquee Text - Center */}

      <div className="marquee-section flex-1 flex justify-center overflow-hidden mr-6">
        <div className="relative w-full max-w-3xl">
          {announcements.length > 0 && (
            <div className="whitespace-nowrap animate-marquee">
              {announcements.map((announcement, index) => (
                <span
                  key={announcement._id}
                  className={`announcement-item inline-block mx-8 cursor-pointer font-medium text-2xl text-[#470172] transition-colors duration-200 ${announcement.url ? 'hover:text-[#d24e1a]' : ''
                    }`}
                 
                  onClick={() => handleAnnouncementClick(announcement.url)}
                  title={announcement.title}
                >
                  {announcement.content}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Contact Info - Right of Marquee */}
      <div className="contact-section flex flex justify-end items-center">
        <div className="contact-wrapper flex items-center h-full  text-white px-6 border-l-2 border-blue-700">
          {config.phones && config.phones.length > 0 && (
            <a
              href={`tel:${config.phones[0]}`}
              className="contact-phone flex items-center space-x-2 text-[#470172] hover:text-[#d24e1a] transition-colors px-4 h-full text-2xl"
            >
              <FaPhone className="text-xl" />
              <span className="contact-phone-text">{config.phones[0]}</span>
            </a>
          )}
          {config.emails && config.emails.length > 0 && (
            <a
              href={`mailto:${config.emails[0]}`}
              className="contact-email flex items-center space-x-2 text-[#470172] hover:text-[#d24e1a] transition-colors px-3 h-full border-l border-violet-600 text-2xl"
            >
              <FaEnvelope className="text-xl" />
              <span className="contact-email-text">{config.emails[0]}</span>
            </a>
          )}
        </div>
      </div>

      {/* Social Media Icons - Right-most */}
      <div className="social-section flex items-center justify-center space-x-6 px-6 h-full  text-white border-l-2 border-[#470172]-700">
        {config.socialLinks?.facebook && (
          <a
            href={config.socialLinks.facebook}
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon text-[#470172] hover:text-[#d24e1a] transition-all duration-200 hover:scale-125 text-3xl"
          >
            <FaFacebook className="text-3xl" />
          </a>
        )}
        {config.socialLinks?.twitter && (
          <a
            href={config.socialLinks.twitter}
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon text-[#470172] hover:text-[#d24e1a] transition-all duration-200 hover:scale-125 text-xl"
          >
            <FaXTwitter className="text-3xl" />
          </a>
        )}
        {config.socialLinks?.linkedin && (
          <a
            href={config.socialLinks.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon text-[#470172] hover:text-[#d24e1a] transition-all duration-200 hover:scale-125 text-xl"
          >
            <FaLinkedin className="text-3xl" />
          </a>
        )}
        {config.socialLinks?.instagram && (
          <a
            href={config.socialLinks.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon text-[#470172] hover:text-[#d24e1a] transition-all duration-200 hover:scale-125 text-xl"
          >
            <FaInstagram className="text-3xl" />
          </a>
        )}
        {config.socialLinks?.youtube && (
          <a
            href={config.socialLinks.youtube}
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon text-[#470172] hover:text-[#d24e1a] transition-all duration-200 hover:scale-125 text-xl"
          >
            <FaYoutube className="text-3xl" />
          </a>
        )}
      </div>
    </div>
  );
};

export default TopUtilityHeader;
